<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { _ } from 'svelte-i18n';

  import PlusCircle from '../icons/PlusCircle.svelte';
  import MinusCircle from '../icons/MinusCircle.svelte';
  import ChevronRight from '../icons/ChevronRight.svelte';
  import { AppState } from '../../etc/stores';
  import flags from '../../etc/flagKeys';

  export let pendingAmount = '';
  export let expiringAmount = '';

  const dispatch = createEventDispatcher();

  $: expirableCoinsIsActive = $AppState.featureFlags.includes(flags.EXPIRABLE_COINS);

  const t = (text: string) => $_(`coin_status_box.${text}`);
  const isDisable = (value: string) => parseFloat(value) === 0;
</script>

<button class="twm-coin-status" on:click={() => dispatch('click')}>
  <div class="twm-coin-status__item">
    <span class="twm-coin-status__text">
      {t('pending')}
    </span>
    <div class="twm-coin-status__icon" class:twm-coin-status--disabled={isDisable(pendingAmount)}>
      <PlusCircle fill={isDisable(pendingAmount) ? '#FFF' : '#21B908'} />
    </div>
    <span class="twm-coin-status__text twm-coin-status__text--amount" class:twm-coin-status--disabled={isDisable(pendingAmount)}>
      {pendingAmount}
    </span>
  </div>
  {#if expirableCoinsIsActive}
  <div class="twm-coin-status__item">
    <span class="twm-coin-status__text">
      {t('expiring')}
    </span>
    <div class="twm-coin-status__icon" class:twm-coin-status--disabled={isDisable(expiringAmount)}>
      <MinusCircle fill={isDisable(expiringAmount) ? '#FFF' : '#F8A038'} />
    </div>
    <span class="twm-coin-status__text twm-coin-status__text--amount" class:twm-coin-status--disabled={isDisable(expiringAmount)}>
      {expiringAmount}
    </span>
  </div>
  {/if}
  <div class="twm-coin-status__item twm-coin-status--arrow-right">
    <ChevronRight size="16" color="white" />
  </div>
</button>

<style lang="scss">
  .twm-coin-status {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background: rgba(#000, 0.09);
    margin-top: 16px;
    gap: 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease-in-out;
    border: 0;

    &:hover {
      background: rgba(#000, 0.06);
    }

    &__text {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: #FFF;
      letter-spacing: -0.02em;

      &--amount {
        font-weight: 500;
      }
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    &__icon {
      display: flex;
    }

    &--disabled {
      opacity: 0.60;
    }

    &--arrow-right {
      margin-left: -8px;
    }
  }
</style>
